var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"strategy-content"},[(_vm.strategyContent)?_c('div',{staticClass:"strategy-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strategyContent)}})]):_c('div',{staticClass:"no-strategy"},[_c('p',[_vm._v("暂无相关攻略内容")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }